import { useQuery } from '@tanstack/react-query';
import type { components } from '@copilot/shared-types';
import axios from 'axios';
import { httpClient } from '../../shared/http/client';
import { queryKeys } from '../../shared/data/queryKeys';

export type ConsentLog = components['schemas']['ConsentLogPublic'];

async function fetchConsent(meetingId: string): Promise<ConsentLog | null> {
  try {
    const response = await httpClient.get<ConsentLog>(`/api/v1/meetings/${meetingId}/consent`);
    return response.data;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 404) return null;
    throw err;
  }
}

export function useSessionConsent(meetingId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.consent(meetingId ?? ''),
    queryFn: () => fetchConsent(meetingId as string),
    enabled: meetingId !== undefined && meetingId.length > 0,
  });
}
